// ROGUE - Rows of generated unicode entries

export const textToRogue = ({
    text,
    maxCharacterCount,
    mergeFields,
}) => {
    let length = 0;
    const lines = text.split('\n');

    const rows = lines.map((line, i) => {
        const delimiters = Object.keys(mergeFields);
        let slices = [line];

        delimiters.forEach((delimiter) => {
            slices = slices.flatMap((lineToParse) => {
                return lineToParse
                    .split(delimiter)
                    .reduce((acc, v) => acc.concat(v, delimiter), [])
                    .slice(0, -1);
            });
        });

        const values = slices
            .flatMap((value) => {
                length += value.length;

                const hasOverflow = length > maxCharacterCount;

                if (Object.keys(mergeFields).includes(value)) {
                    return {
                        type: 'component',
                        component: 'chip',
                        label: mergeFields[value],
                        text: value,
                        ...(hasOverflow && { isOverflow: true }),
                    };
                }

                if (hasOverflow && length - value.length < maxCharacterCount) {
                    const overflowCharacterCount = length - maxCharacterCount;
                    const validCharacterCount = value.length - overflowCharacterCount;
                    const validValue = value.slice(0, validCharacterCount);
                    const overflowValue = value.slice(validCharacterCount);

                    return [
                        {
                            type: 'text',
                            text: validValue,
                        },
                        {
                            type: 'text',
                            text: overflowValue,
                            isOverflow: true,
                        },
                    ];
                }

                return {
                    type: 'text',
                    text: value,
                    ...(hasOverflow && { isOverflow: true }),
                };
            });

        // Handle new line characters at the end of each line (except for the last line)
        if (i !== lines.length - 1) {
            length += 1;
        }

        return { values };
    });

    return { rows };
};
